import './personalNotesNavigation.js';
import './navigationGuard.js';
import './inbox/notificationNavigation.js';
import { installPhoneLifecycle } from './inbox/phoneEnrollment.js';
import { installInboxUpdates } from './inbox/appUpdates.js';
import { mount } from 'svelte';
import App from './App.svelte';

installPhoneLifecycle();
installInboxUpdates();

const app = mount(App, {
	target: document.body,
	intro: false,
	props: {
		name: 'world'
	}
});

export default app;
